// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"ae4a51cb","285":"1c3339c1","505":"9af7075d","611":"4b814c6a","631":"3722b83e","652":"7707fd23","934":"4c5c4de3"}[chunkId] + ".chunk.js";
};